
<script>

	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
	import { createEventDispatcher } from 'svelte';
  
	/* IMPORT: 3RD-PARTY */
	
	/* IMPORT: CUSTOM JS */
	import { restProp }	from '$lib/script/restprop.js';

	export let base = 
	{ 
		//id: `button-${ Math.random() * 10000 }`,
		class: { 
			prefix: true, 
			value: 'button' 
		}
	};

	let button = null;



    const dispatch = createEventDispatcher();

    function buttonClicked() {
        dispatch('message', {
            element: button
        });
    }

	/* Svelte Methods */
	
	onMount( async () =>
	{
		// #Await...
		//await tick();

		$$restProps = restProp({
			type: 'Button',
			restProp: $$restProps,
			base: base,
			required: ['aria-label']
		});

	});
  
</script>

<button bind:this={ button } on:click={ buttonClicked } data-id='eyCT2h' {...$$restProps}>
	<slot />
</button>


<style lang='scss'>

	@media screen and (min-width: theme('screens.md'))
	{	
		:global( :where( [data-id='eyCT2h'] ) )
		{
			--btn-min-width: 237px;
			--btn-max-width: 100%;
		}
	}

	:global( :where( [data-id='eyCT2h'] ) )
	{
		text-transform: uppercase;
		text-align: center;
		font-family: 'Gilroy-Black', sans-serif;
		font-size: 14px;
		// width: var(--btn-min-width);
		// min-width: var(--btn-min-width, 100%);
		// max-width: var(--btn-max-width, 100%);
		// height: 100%;
		// min-height: 61px;
		cursor: pointer;
	}

	:global( :where( [data-id='eyCT2h']:not( .unstyled ) ) )
	{
		width: var(--btn-min-width);
		min-width: var(--btn-min-width, 100%);
		max-width: var(--btn-max-width, 100%);
		height: 100%;
		min-height: 61px;
	}


	:where( [data-id='eyCT2h'] ).button-grey
	// :where( [data-id='eyCT2h'] ) :global( .button-black-white )
	{
		color: var(--clr-black-static);
		background-color: var(--clr-gray-dark-static);
		//animation: bgWhite2Black .35s linear forwards;
	}

	:where( [data-id='eyCT2h'] ).button-black-white,
	:where( [data-id='eyCT2h'] ) :global( .button-black-white )
	{
		color: var(--clr-white-static);
		background-color: var(--clr-black-static);
		animation: bgWhite2Black .35s linear forwards;
	}

	:where( [data-id='eyCT2h'] ).button-black-white:hover,
	:where( [data-id='eyCT2h'] ) :global( .button-black-white:hover ) 
	{
		animation: bgBlack2White .35s linear forwards;
	}

	
	
	:where([data-id='eyCT2h']).button-black-red,
	:where([data-id='eyCT2h']) :global( .button-black-red )
	{
		color: var(--clr-white-static);
		background-color: var(--clr-black-static);
		animation: bgRed2Black .35s linear forwards;
	}

	:where([data-id='eyCT2h']).button-black-red:hover
	:where([data-id='eyCT2h']) :global( .button-black-red:hover )
	{
		animation: bgBlack2Red .35s linear forwards;
	}


	
	:where([data-id='eyCT2h']).button-red-black,
	:where([data-id='eyCT2h']) :global( .button-red-black )
	{
		color: var(--clr-white-static);
		background-color: var(--clr-red-static);
		animation: bgBlack2Red2 .35s linear forwards;
	}

	:where([data-id='eyCT2h']).button-red-black:hover,
	:where([data-id='eyCT2h']) :global( .button-red-black:hover )
	{
		animation: bgRed2Black2 .35s linear forwards;
	}

	:where([data-id='eyCT2h']).button-red-white,
	:where([data-id='eyCT2h']) :global( .button-red-white )
	{
		color: var(--clr-white-static);
		background-color: var(--clr-red-static);
		animation: bgRed2White .35s linear forwards;
	}

	:where([data-id='eyCT2h']).button-red-white:hover,
	:where([data-id='eyCT2h']) :global( .button-red-white:hover )
	{
		animation: bgWhite2Red .35s linear forwards;
	}



	:where([data-id='eyCT2h']).button-white-red,
	:where([data-id='eyCT2h']) :global( .button-white-red )
	{
		color: var(--clr-red-static);
		background-color: var(--clr-white-static);
		animation: bgWhite2Red .35s linear forwards;
	}

	:where([data-id='eyCT2h']).button-white-red:hover,
	:where([data-id='eyCT2h']) :global( .button-white-red:hover )
	{
		animation: bgRed2White .35s linear forwards;
	}


	@keyframes bgBlack2Red
	{
		to { color: var(--clr-black-static); background-color:  var(--clr-red-static); }
		from { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
	}

	@keyframes bgRed2Black 
	{
		from { color: var(--clr-black-static); background-color:  var(--clr-red-static); }
		to { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
	}

	@keyframes bgBlack2White 
	{
		from { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
		to { color: var(--clr-black-static); background-color:  var(--clr-white-static); }
	}

	@keyframes bgWhite2Black 
	{
		from { color: var(--clr-black-static); background-color:  var(--clr-white-static); }
		to { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
	}

	@keyframes bgBlack2Red2
	{
		from { color: var(--clr-white-static); background-color: var(--clr-black-static); }
		to { color: var(--clr-white-static); background-color:  var(--clr-red-static); }
	}

	@keyframes bgRed2Black2 
	{
		from { color: var(--clr-black-static); background-color:  var(--clr-red-static); }
		to { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
	}

	@keyframes bgWhite2Red
	{
		from { color: var(--clr-white-static); background-color: var(--clr-black-static); }
		to { color: var(--clr-red-static); background-color:  var(--clr-white-static); }
	}

	@keyframes bgRed2White 
	{
		from { color: var(--clr-red-static); background-color:  var(--clr-white-static); }
		to { color: var(--clr-white-static); background-color:  var(--clr-black-static); }
	}

</style>